<template>
  <v-container
    id="city-progress"
  >
    <v-row>
      <v-col
        md="3"
        sm="3"
        lg="3"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              Eventos
            </h1>
          </span>
        </v-alert>
        <pie-chart
          :chart-data="chartDataEncontros"
          :options="chartOptions"
          :width="200"
          :height="200"
        >
        </pie-chart>
      </v-col>

      <v-col
        md="3"
        sm="3"
        lg="3"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              Relatórios
            </h1>
          </span>
        </v-alert>
        <pie-chart
          :chart-data="chartDataRelatorios"
          :options="chartOptions"
          :width="200"
          :height="200"
        >
        </pie-chart>
      </v-col>

      <v-col
        md="3"
        sm="3"
        lg="3"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              Relatórios Adm
            </h1>
          </span>
        </v-alert>
        <pie-chart
          :chart-data="chartDataRelatoriosAdm"
          :options="chartOptions"
          :width="200"
          :height="200"
        >
        </pie-chart>
      </v-col>

      <v-col
        md="3"
        sm="3"
        lg="3"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              Andamentos Perguntas
            </h1>
          </span>
        </v-alert>
        <pie-chart
          :chart-data="chartDataAndamentosPerguntas"
          :options="chartOptions"
          :width="200"
          :height="200"
        >
        </pie-chart>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="cities"
          item-key="municipio.municipioId"
          class="elevation-1"
          :loading="loading"
          loading-text="Obtendo informações ..."
          show-expand
          single-expand
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.andamento="{ item }">
            {{ item.gruposSolucaoConcluidos }} / {{ item.totalGruposSolucao }}
          </template>

          <template v-slot:item.percental="{ item }">
            {{ item.percentual }} %
          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="4" class="td-without-padding">
              <app-group-solutions-table :grupoSolutions="item.gruposSolucoes"></app-group-solutions-table>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PieChart from '@/components/chart/PieChart'
// import { administrativeDashboardAPI } from '@/modules/administrative-dashboard'
import { mapActions } from 'vuex'
import AppGroupSolutionsTable from './GroupSolutionsTable'

export default {
  components: {
    PieChart,
    AppGroupSolutionsTable
  },
  props: {
    chartDataEncontros: {},
    chartDataAndamentosPerguntas: {},
    chartDataRelatoriosAdm: {},
    chartDataRelatorios: {},
    cities: {},
    loading: {}

  },
  data () {
    return {

      headers: [
        { text: 'Município', value: 'municipio.nome' },
        { text: 'Andamento', value: 'andamento' },
        { text: 'Percentual', value: 'percentual' }
      ],
      expanded: false,
      chartOptions: {
        hoverBorderWidth: 10
      }
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ])
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
